import { BaseModel } from 'storm-react-diagrams';
import {
  DesignClass,
  DesignMap,
  GenericDesignChangeItem
} from '@app/types';
import {
  BaseLinkModel,
  IntentDataModel,
  VariableDataModel
} from '../../../../models';
import NodeRegistry from '../../../NodeRegistry';
import { getChangeItemObject } from './get-change-item-object';

export interface GetChangeItemModelProps {
  changeItem: GenericDesignChangeItem;
  designMap: DesignMap;
  key: string;
}

export function getChangeItemModel({
  changeItem,
  designMap,
  key
}: GetChangeItemModelProps): BaseModel<any> | null {
  const changeObject = getChangeItemObject(changeItem);

  if (
    !changeObject
    || typeof changeObject !== 'object'
    || !('_class' in changeObject)
  ) {
    return null;
  }

  if (changeObject._class === DesignClass.link) {
    const [, moduleId] = key.split('.');
    const moduleNodes = designMap.moduleNodes.get(moduleId);
    const createPortModel = (linkNode: 'source' | 'target'): any => {
      const nodeId = changeObject[linkNode];
      const nodeObject = moduleNodes?.get(nodeId);
      const node = (!nodeObject) ? null : NodeRegistry.buildNode(nodeObject);
      return (!node) ? null : (
        node.getPorts()[changeObject[`${linkNode}Port`]]
      );
    };
    return new BaseLinkModel(
      createPortModel('source'),
      createPortModel('target'),
      changeObject.props,
      changeObject.id,
      changeObject.points
    );
  } else if (changeObject._class === DesignClass.intent) {
    return new IntentDataModel(
      changeObject.name,
      0,
      0,
      changeObject.props,
      changeObject.id
    );
  } else if (changeObject._class === DesignClass.variable) {
    return new VariableDataModel(
      changeObject.props,
      changeObject.id
    );
  }

  return NodeRegistry.buildNode(changeObject);
}
